
import { useEffect, useRef, useState } from 'react';

export const MAX_LISTEN_TIMER = 5000;

/**
 * a max listening timer used to help determine if the user has moved the current word index before the phrase time ends.
 * this helps us to know if the current word index was moved by the user instead of by the phrase auto advance logic.
 * this timer does not block anything, it is just a helper timer.
 * @returns 
 */
export default function useMaxListenTimer() {

  const timer = useRef(null);
  const [ maxListenTimerEnded, setMaxListenTimerEnded ] = useState(false);

  useEffect(() => {
    return () => {
      stopTimer();
    }
  }, []);

  const startTimer = () => {
    setMaxListenTimerEnded(false);
    timer.current = setTimeout(() => {
      setMaxListenTimerEnded(true);
    }, MAX_LISTEN_TIMER);
  };

  const stopTimer = () => {
    setMaxListenTimerEnded(false);
    clearTimeout(timer.current);
  };

  return {
    maxListenTimerEnded,
    maxListenTimer: timer.current,
    startMaxListenTimer: startTimer,
    stopMaxListenTimer: stopTimer,
  };

}